import { InputField } from '@common/InputField';
import { Typography, useTheme } from '@mui/material';

interface FormInputProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label?: string;
  errorMessage?: string;
}

export const FormInput = ({ label, errorMessage, ...rest }: FormInputProps) => {
  const theme = useTheme();

  return (
    <div
      style={{
        flexDirection: 'column',
        display: 'flex',
        gap: '12px',
      }}
    >
      {label && (
        <Typography variant="body2" color={theme.palette.text.secondary}>
          {label}
        </Typography>
      )}
      <InputField
        errorMessage={errorMessage}
        {...rest}
        aria-label={rest['aria-label'] ?? label}
      />
    </div>
  );
};
